import type { Point } from '@/domain/world/geometry';
import type { RegionRegistry } from '@/domain/world/region-registry';

export function cameraViewForWorldPoint(registry: RegionRegistry, point: Point) {
  return registry.regionAtWorldPoint(point).camera;
}

export function cameraViewForRegion(registry: RegionRegistry, regionId: string) {
  return (registry.get(regionId) ?? registry.regionAtWorldPoint({ x: 0, y: 0 })).camera;
}

export function worldYSortDepth(groundY: number): { object: number; shadow: number } {
  const object = Number.isFinite(groundY) ? groundY : 0;
  return { object, shadow: object - 0.5 };
}
